import { Step } from 'react-joyride';

export const agentsTourSteps: Step[] = [
  {
    target: '[data-tour="agents-header"]',
    content: (
      <div>
        <h4>Agent Management</h4>
        <p>
          Manage your team members here. Add new agents, edit existing ones, and monitor their
          status and performance.
        </p>
      </div>
    ),
    placement: 'bottom',
    disableBeacon: true
  },
  {
    target: '[data-tour="add-agent-button"]',
    content: (
      <div>
        <h4>Add New Agent</h4>
        <p>
          Click here to invite new team members to your dashboard. Assign roles and permissions
          during setup.
        </p>
      </div>
    ),
    placement: 'bottom'
  },
  {
    target: '[data-tour="search-agents"]',
    content: (
      <div>
        <h4>Search Agents</h4>
        <p>Quickly find specific agents by name, email, or other criteria.</p>
      </div>
    ),
    placement: 'bottom'
  },
  {
    target: '[data-tour="agents-table"]',
    content: (
      <div>
        <h4>Agents List</h4>
        <p>
          View all your agents with their status, roles, teams, and last login information. Click on
          any row to view or edit agent details.
        </p>
      </div>
    ),
    placement: 'top'
  },
  {
    target: '[data-tour="agent-actions"]',
    content: (
      <div>
        <h4>Agent Actions</h4>
        <p>
          Access more options like editing agent details, changing permissions, or removing them
          from your team.
        </p>
      </div>
    ),
    placement: 'left'
  }
];
